/**
 * 自动导出任务api
 */
 import httpRequest from '@/utils/request.js';

  /**查询导出任务列表 */
  export const getExportListPage = (params = {}) =>
  httpRequest.httpGet({
      url: '/service/task/exprot/lst',
      params: {
          ...params
      }
  });
// 删除导出任务（单个）
export const exportTaskDel = (id)  =>
httpRequest.httpdelete( `/service/task/exprot/delete`, id)
// 删除导出任务（批量）
export const exportTaskDelBatch = (ids)  =>
httpRequest.httpPost( `/service/task/exprot/delete/batch`, ids)
/**开始导出任务 */
export const startExportTask = (id) =>
    httpRequest.httpGet({
        url: `/service/task/exprot/start/${id}`,
    });
/**停止导出任务 */
export const stopExportTask = (id) =>
    httpRequest.httpGet({
        url: `/service/task/exprot/stop/${id}`,
    });
//任务新增
export const addExportTask = (data)  =>
    httpRequest.httpPost( `/service/task/exprot/add`, data)
//任务更新
export const updateExportTask = (data)  =>
    httpRequest.httpPost( `/service/task/exprot/update`, data)
/**任务详情 */
export const getExportTaskDetail = (id) =>
    httpRequest.httpGet({
        url: `/service/task/exprot/get/${id}`,
    });

/**自动导出任务历史分页查询 */
export const getExportHistory = (params = {}) =>
  httpRequest.httpGet({
      url: '/service/task/exprot/his/page',
      params: {
          ...params
      }
  });
/**自动导出任务历史下载 */
export const exportHisDownload = (params = {}) =>
    httpRequest.download('/service/task/exprot/his/download', params);
// 删除导出任务历史（批量）
export const exportHisDelBatch = (ids)  =>
httpRequest.httpPost( `/service/task/exprot/his/delete/batch`, ids)